import React, { useState, useEffect, useRef } from "react";

import "./guest-input.css";
import Button from "../global/button";

function GuestInput({ searchCriteria = {}, setSearchCriteria, setErrors }) {
  const guests = searchCriteria.guests || {};

  const adultCount = guests.adultCount;
  const childCount = guests.childCount;
  const childAges = guests.childAges;
  const roomCount = guests.roomCount;

  let [opened, setIsOpened] = useState(false);

  function addAdult() {
    setSearchCriteria((prev) => {
      const prevAdultCount = prev.guests.adultCount;
      if (prevAdultCount < 30) {
        return {
          ...prev,
          guests: {
            ...prev.guests,
            adultCount: prevAdultCount + 1,
          },
        };
      } else {
        return { ...prev };
      }
    });
  }
  function subAdult() {
    setSearchCriteria((prev) => {
      const prevGuests = prev.guests;
      const prevAdultCount = prevGuests.adultCount;
      const prevRoomCount = prevGuests.roomCount;

      if (prevAdultCount > 0) {
        const newGuests = {
          ...prev.guests,
          adultCount: prevAdultCount - 1,
        };

        if (prevRoomCount === prevAdultCount) {
          newGuests.roomCount = prevRoomCount - 1;
        }

        return {
          ...prev,
          guests: newGuests,
        };
      } else {
        return { ...prev };
      }
    });
  }

  /** Children Counter */
  function addChild() {
    setSearchCriteria((prev) => {
      const prevGuests = prev.guests;
      const prevChildCount = prevGuests.childCount;

      if (prevChildCount < 10) {
        return {
          ...prev,
          guests: {
            ...prev.guests,
            childCount: prevChildCount + 1,
            childAges: [...prev.guests.childAges, -1],
          },
        };
      } else {
        return { ...prev };
      }
    });
  }
  function subChild() {
    setSearchCriteria((prev) => {
      const prevGuests = prev.guests;
      const prevChildCount = prevGuests.childCount;
      const prevChildAges = prevGuests.childAges;

      if (prevChildCount > 0) {
        const newChildAges = prevChildAges.slice(0, -1);

        const isValidAge = newChildAges.every((age) => age >= 0 && age < 18);

        setErrors((prev) => {
          return {
            ...prev,
            guests: isValidAge ? null : "Please select the child age",
          };
        });

        return {
          ...prev,
          guests: {
            ...prevGuests,
            childCount: prevChildCount - 1,
            childAges: newChildAges,
          },
        };
      } else {
        return { ...prev };
      }
    });
  }

  function childAgeSelection(e, i) {
    const childAge = e.target.value;

    const newChildAges = childAges.map((age, index) => {
      if (index === i) {
        return parseInt(childAge);
      }
      return age;
    });

    const isValidAge = newChildAges.every((age) => age >= 0 && age < 18);

    setErrors((prev) => {
      return {
        ...prev,
        guests: isValidAge ? null : "Please select the child age",
      };
    });

    setSearchCriteria((prev) => {
      return {
        ...prev,
        guests: {
          ...prev.guests,
          childAges: newChildAges,
        },
      };
    });
  }

  const dropDownRef = useRef();
  const inputRef = useRef();

  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash !== "#overlay") {
        setIsOpened(false);
      }
    };

    function ListenClick(e) {
      let dropdownBoxClicked = e.target.closest("#guest-dropdown");

      let isSearchBtn = e.target.closest("#home-search-btn");
      let isSearchBtn2 = e.target.closest("#single-prop-search-btn");
      let isSearchBtn3 = e.target.closest(".search-btn");

      const isOneOfSearchBtn = !!isSearchBtn || !!isSearchBtn2 || !!isSearchBtn3;

      if (!dropdownBoxClicked && !isOneOfSearchBtn) {
        setIsOpened(false);
      }

      if (e.target === inputRef.current) {
        setIsOpened(!opened);
      }
    }

    window.addEventListener("hashchange", handleHashChange);
    document.addEventListener("click", ListenClick);
    document.addEventListener("focusin", ListenClick);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
      document.removeEventListener("click", ListenClick);
      document.removeEventListener("focusin", ListenClick);
    };
  }, []);

  useEffect(() => {
    if (opened) {
      if (window.location.hash === "#overlay") {
        window.history.replaceState(null, null, "#overlay");
      } else {
        window.history.pushState(null, null, "#overlay");
      }
    }
    // else {
    //   window.history.replaceState(
    //     null,
    //     null,
    //     window.location.pathname + window.location.search
    //   );
    // }

    function handleFocusIn(event) {
      const target = event.target;
      const parent = event.target.offsetParent;

      if (!opened) return;

      if (target.className !== "guest-input-search-input" && parent.className !== "guest-dropdown") {
        setIsOpened(false);
      }
    }

    document.addEventListener("focusin", handleFocusIn);

    return () => {
      document.removeEventListener("focusin", handleFocusIn);
    };
  }, [opened]);

  function subRooms() {
    setSearchCriteria((prev) => {
      const prevGuests = prev.guests;
      const prevRoomCount = prevGuests.roomCount;

      if (prevRoomCount > 1) {
        return {
          ...prev,
          guests: {
            ...prevGuests,
            roomCount: prevRoomCount - 1,
          },
        };
      } else {
        return { ...prev };
      }
    });
  }

  function addRooms() {
    setSearchCriteria((prev) => {
      const prevGuests = prev.guests;
      const prevRoomCount = prevGuests.roomCount;
      const prevAdultCount = prevGuests.adultCount;

      if (prevRoomCount < 30) {
        return {
          ...prev,
          guests: {
            ...prevGuests,
            roomCount: prevRoomCount + 1,
            adultCount: prevRoomCount + 1 > prevAdultCount ? prevRoomCount + 1 : prevAdultCount,
          },
        };
      } else {
        return { ...prev };
      }
    });
  }

  function handleSubmit() {
    setIsOpened(false);
  }

  return (
    <div id="guest" className="guest-input-search-main">
      <input
        type="text"
        name=""
        ref={inputRef}
        className={`guest-input-search-input`}
        id="guest-input-drop-down"
        // placeholder={`${adult} Adults, ${child} Children, ${roomCount} Rooms`}
        value={`${adultCount} ${adultCount > 1 ? "Adults" : "Adult"}, ${childCount} Children, ${roomCount} ${roomCount > 1 ? "Rooms" : "Room"}`}
        onChange={(e) => {
          e.preventDefault();
        }}
        readOnly
        aria-haspopup="true"
        aria-expanded={opened}
        aria-controls="guest-dropdown"
      />
      {opened ? (
        <div
          className={`guest-dropdown`}
          // mount-animation ${ show && !opened && "unmount-animation"}
          id="guest-dropdown"
          ref={dropDownRef}
          aria-labelledby="guest-input-drop-down"
        >
          <div className="guest-options">
            <div className="guest-name">
              <span>Adults</span>
            </div>

            <div
              className="counter"
              style={{
                "--width": "132.5px",
                "--btn-width": "36px",
                "--font-size": "16px",
                "--gap": "20px",
              }}
            >
              <button className="counter-dec-btn" onClick={subAdult} disabled={adultCount <= 1} type="button"></button>
              <span>{adultCount}</span>
              <button className="counter-inc-btn" onClick={addAdult} disabled={adultCount === 30} type="button"></button>
            </div>
          </div>

          <div className="guest-options">
            <div className="guest-name">
              <span>Children</span>
            </div>

            {/* i am copy past the button code because here inc and dec function is not same as other counters */}
            <div
              className="counter"
              style={{
                "--width": "132.5px",
                "--btn-width": "36px",
                "--font-size": "16px",
                "--gap": "20px",
              }}
            >
              <button className="counter-dec-btn" onClick={subChild} disabled={childCount <= 0} type="button"></button>
              <span>{childCount}</span>
              <button className="counter-inc-btn" onClick={addChild} disabled={childCount === 10} type="button"></button>
            </div>
          </div>

          {childCount > 0 && (
            <div className="child-age-wrapper">
              <p>Please provide the ages of your children at the time of Booking.</p>
              <div className="select-child-ages">
                {childAges.map((age, i) => {
                  const condition = age >= 0;

                  return (
                    <select
                      key={`child-${i + 1}`}
                      name={`child-${i + 1}`}
                      id="age"
                      value={age}
                      onChange={(e) => childAgeSelection(e, i)}
                      style={{
                        border: `1px solid ${condition ? "#707070" : "red"}`,
                      }}
                    >
                      <option value="-1">Age needed</option>
                      <option value="0">0 years old</option>
                      <option value="1">1 year old</option>
                      <option value="2">2 years old</option>
                      <option value="3">3 years old</option>
                      <option value="4">4 years old</option>
                      <option value="5">5 years old</option>
                      <option value="6">6 years old</option>
                      <option value="7">7 years old</option>
                      <option value="8">8 years old</option>
                      <option value="9">9 years old</option>
                      <option value="10">10 years old</option>
                      <option value="11">11 years old</option>
                      <option value="12">12 years old</option>
                      <option value="13">13 years old</option>
                      <option value="14">14 years old</option>
                      <option value="15">15 years old</option>
                      <option value="16">16 years old</option>
                      <option value="17">17 years old</option>
                    </select>
                  );
                })}
              </div>
            </div>
          )}

          <div className="guest-options">
            <div className="guest-name">
              <span>Rooms</span>
            </div>

            <div
              className="counter"
              style={{
                "--width": "132.5px",
                "--btn-width": "36px",
                "--font-size": "16px",
                "--gap": "20px",
              }}
            >
              <button className="counter-dec-btn" onClick={subRooms} disabled={roomCount <= 1} type="button"></button>
              <span>{roomCount}</span>
              <button className="counter-inc-btn" onClick={addRooms} disabled={roomCount === 30} type="button"></button>
            </div>
          </div>
          <Button width="100%" size="md" padding="10px 0" className="guest-input-submit" onClick={handleSubmit}>
            Done
          </Button>
        </div>
      ) : null}
    </div>
  );
}

export default GuestInput;
